import { DEFAULT_CME_ID } from '../Constants/ServerValues'
import { AdminUserResponse } from '../../../NonReact/common/Types/Types'

const DEVOPS_ADMIN_USERNAME: string = 'Admin'

export const isDevOpsAdmin = (userInfo: Nullable<AdminUserResponse>): boolean =>
    userInfo?.Scope?.CMEnvironmentID === DEFAULT_CME_ID &&
    (userInfo?.Permissions?.Admin?.length ?? 0) > 0 &&
    userInfo?.Username === DEVOPS_ADMIN_USERNAME
